// Customer-facing feature flags. Flip to true to re-expose the feature in the UI.
export const ATLAS_ASSISTANT_ENABLED = false;
